export const ENTITY_QUERY_LIMIT = 50;
